import React from 'react';
import PropTypes from 'prop-types';

/**
 * Reusable CTA (Call-to-Action) section component
 * Used at the bottom of most pages to encourage user engagement
 */
const CTASection = ({ 
  title, 
  description, 
  primaryButton, 
  secondaryButton,
  contactInfo = null,
  className = '' 
}) => {
  return (
    <div className={`bg-main-600 p-48 rounded-3 text-center ${className}`}>
      <h2 className="text-white mb-16">{title}</h2>
      <p className="text-white mb-32 max-w-600 mx-auto">{description}</p>

      {contactInfo && (
        <div className="d-flex align-items-center justify-content-center gap-32 flex-wrap mb-32">
          {contactInfo.email && (
            <div className="d-flex align-items-center gap-12 text-white">
              <i className="ph ph-envelope text-xl"></i>
              <span>{contactInfo.email}</span>
            </div>
          )}
          {contactInfo.phone && (
            <div className="d-flex align-items-center gap-12 text-white">
              <i className="ph ph-phone text-xl"></i>
              <span>{contactInfo.phone}</span>
            </div>
          )}
          {contactInfo.address && (
            <div className="d-flex align-items-center gap-12 text-white">
              <i className="ph ph-map-pin text-xl"></i>
              <span>{contactInfo.address}</span>
            </div>
          )}
        </div>
      )}

      <div className="flex-center gap-16">
        {primaryButton && (
          <a href={primaryButton.href} className="btn btn-white rounded-pill">
            {primaryButton.icon && <i className={`${primaryButton.icon} me-8`} />}
            {primaryButton.text}
          </a>
        )}
        {secondaryButton && (
          <a href={secondaryButton.href} className="btn btn-outline-white rounded-pill">
            {secondaryButton.icon && <i className={`${secondaryButton.icon} me-8`} />}
            {secondaryButton.text}
          </a>
        )}
      </div>
    </div>
  );
};

CTASection.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  primaryButton: PropTypes.shape({
    text: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    icon: PropTypes.string
  }),
  secondaryButton: PropTypes.shape({
    text: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    icon: PropTypes.string
  }),
  contactInfo: PropTypes.shape({
    email: PropTypes.string,
    phone: PropTypes.string,
    address: PropTypes.string
  }),
  className: PropTypes.string
};

export default CTASection;
